import React from "react";
import styled from "styled-components";
import { colors } from "../../utils/theme";
import RevealOnScroll from "../../utils/RevealOnScroll";
import WorkButtons from "../Header/WorkButtons";
import { SiAdobepremierepro, SiAdobeaftereffects, SiHuggingface, SiBlender, SiUnrealengine } from "react-icons/si";
import { motion } from "framer-motion";
import TextShift from "../../utils/TextShift";
import { Link } from "react-router-dom";
import ExperimentContainer from "../Experiments/ExperimentContainer";
import experimentsData from "../../utils/experiments.json";

const PlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  color: white;
  background: transparent;
  padding: 0 1rem 4rem;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 0 0.5rem 3rem;
  }
`;

const TitleContainer = styled.div`
  margin-top: 6rem;
  margin-bottom: 0;
  opacity: 0.9;
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    margin-top: 1rem;
    padding-bottom: 1.3rem;
  }
`;

const NavigationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: -2rem;
`;

const SubtextContainer = styled.div`
  width: 100%;
  max-width: 800px;
  text-align: left;
  padding: 2rem;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0.5rem;
    max-width: 100%;
  }
`;

const Subtext = styled.p`
  font-family: "maitree", serif;
  font-size: 1.4rem;
  line-height: 1.6;
  color: ${colors.subtitleColor};
  font-weight: 300;
  max-width: 600px;
  margin: 0;
  text-align: left;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    width: 350px;
    padding: 0;
  }
`;

const TechStackContainer = styled.div`
  width: 100%;
  max-width: 800px;
  padding: 1rem 2rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6.4rem;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem 0rem 0;
    gap: 3rem;
    justify-content: center;
    flex-wrap: wrap;
    max-width: 100%;
  }
`;

const TechIcon = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.subtitleColor};
  
  svg {
    width: 2.5rem;
    height: 2.5rem;
  }
  
  @media (max-width: 768px) {
    svg {
      width: 2rem;
      height: 2rem;
    }
  }
`;

const ExperimentsSection = styled.div`
  width: 100%;
  margin-top: 4rem;
  
  @media (max-width: 768px) {
    margin-top: 2rem;
  }
`;

function Play() {
  return (
    <PlayContainer>
      <RevealOnScroll>
        <TitleContainer>
          <TextShift
            text="Play"
            fontSize="10rem"
            mobileFontSize="5rem"
            fontFamily="moret-variable, serif"
            maxWeight={900}
            minWeight={200}
            adjacentWeightChange={100}
          />
        </TitleContainer>
      </RevealOnScroll>

      <RevealOnScroll>
        <NavigationContainer>
          <WorkButtons excludeButton="play" />
        </NavigationContainer>
      </RevealOnScroll>

      <RevealOnScroll>
        <SubtextContainer>
          <Subtext>
            Exploring the intersection of creativity and technology through game development,
            3D modeling, and interactive experiences. From concept to creation, bringing
            imaginative worlds to life.
          </Subtext>
        </SubtextContainer>
      </RevealOnScroll>

      <RevealOnScroll>
        <TechStackContainer>
          <TechIcon>
            <SiAdobepremierepro />
          </TechIcon>
          <TechIcon>
            <SiAdobeaftereffects />
          </TechIcon>
          <TechIcon>
            <SiHuggingface />
          </TechIcon>
          <TechIcon>
            <SiBlender />
          </TechIcon>
          <TechIcon>
            <SiUnrealengine />
          </TechIcon>
        </TechStackContainer>
      </RevealOnScroll>

      <ExperimentsSection>
        <RevealOnScroll>
          <ExperimentContainer experiments={experimentsData} />
        </RevealOnScroll>
      </ExperimentsSection>
    </PlayContainer>
  );
}

export default Play;
